// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".category__category___MmaBc {\n  max-width: 100%;\n  margin-top: 2px;\n}\n", "",{"version":3,"sources":["webpack://./src/components/common/UI/Category/category.less"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,eAAA;AACF","sourcesContent":[".category {\n  max-width: 100%;\n  margin-top: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"category": "category__category___MmaBc"
};
export default ___CSS_LOADER_EXPORT___;
